import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import styles from "./Answer.module.css";

interface AnswerFollowupQuestionsProps {
    followupQuestions: string[];
    onFollowupQuestionClicked?: (question: string) => void;
    showFollowupQuestions?: boolean;
}

export const AnswerFollowupQuestions = ({
    followupQuestions,
    onFollowupQuestionClicked,
    showFollowupQuestions,
}: AnswerFollowupQuestionsProps) => {
    const { t } = useTranslation();

    if (!followupQuestions?.length || !showFollowupQuestions || !onFollowupQuestionClicked) {
        return null;
    }

    return (
        <Stack.Item>
            <Stack
                horizontal
                wrap
                className={styles.followupQuestionsList}
                tokens={{ childrenGap: 6 }}
            >
                <span className={styles.followupQuestionLearnMore}>
                    {t("answer.followupQuestions")}
                </span>
                {followupQuestions.map((x, i) => (
                    <a
                        key={i}
                        className={styles.followupQuestion}
                        title={x}
                        onClick={() => onFollowupQuestionClicked(x)}
                    >
                        {x}
                    </a>
                ))}
            </Stack>
        </Stack.Item>
    );
}; 